import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { mobileLinks } from "routes/navigation/sidebarLinks";

const NavBarWrapper = styled.div`
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-top: 1px solid #ccc;
    z-index: 1000;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

const IconLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 12px;
  padding: 8px;
  border-radius: 8px;
  color: #6b7280; 

  &.active {
    background-color: ;
    color: #6b7280; 
  }
  &.active svg {
    color: #009688;
  }

  svg {
    font-size: 20px;
    color: #6b7280;
  }
  &.active span {
    color: #009688;
  }
  span {
    color: #6b7280; 
  }
`;


const BottomNavBar = () => {
  return (
    <NavBarWrapper>
      {/* {mobileLinks.map((item, i) => (
        <IconLink
          to={item.path}
          key={i}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          <item.icon />
          <span>{item.label}</span>
        </IconLink>
      ))} */}
      {mobileLinks.map((item, i) => (
  <IconLink to={item.path} key={i}>
    <item.icon />
    <span>{item.label}</span>
  </IconLink>
))}

    </NavBarWrapper>
  );
};

export default BottomNavBar;
